import type { FeedbackMessages } from './en';

const da: FeedbackMessages = {
  qualified: {
    title: 'Tak for din deltagelse i denne undersøgelse!',
    text: 'Du kan nu lukke browservinduet.\n\nVi håber at se dig igen snart.',
  },
  quotaFull: {
    title: 'Denne undersøgelse er lukket',
    text: 'Tak for din interesse i vores undersøgelse.\n\nVi har desværre allerede modtaget alle de svar, vi har brug for.\n\nVi håber at se dig i en af vores fremtidige undersøgelser!',
  },
  terminated: {
    title: 'Tak for din feedback!',
    text: 'Vi håber at se dig igen i vores fremtidige undersøgelser. Indtil da ønsker vi dig en god dag.\n\nDu kan nu lukke browservinduet.',
  },
  mismatch: {
    title: 'Tak for din interesse',
    text: 'Du er desværre ikke i målgruppen for denne specifikke undersøgelse.\n\nDu kan lukke denne side.',
  },
  error: {
    title: 'Vi kan ikke behandle din anmodning',
    linkProblemDetailed:
      'Det link, du har fulgt, har problemer. Kontroller, at linket i adressefeltet matcher det, du har fået, og forsøg igen.',
    linkProblemGeneric:
      'Det link, du har fulgt, har problemer. Forsøg venligst igen.',
    contactPerson:
      'Hvis problemet fortsætter, bedes du give den person, du fik linket fra, besked om dette problem.',
  },
};

export default da;
